import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DasboardRoutingModule } from './dasboard-routing.module';
import { AdminComponent } from './admin/admin.component';
import { MrfEmployeeListComponent } from './mrf-employee-list/mrf-employee-list.component';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule } from '@angular/material/sort';
import { UiSwitchModule } from 'ngx-toggle-switch';
import { CreatekicketComponent } from './createkicket/createkicket.component';

import { Select2Module } from 'ng-select2-component';
import { TicketmasterComponent } from './ticketmaster/ticketmaster.component';

import { EmployeeprofileComponent } from './employeeprofile/employeeprofile.component';
import { EmployeemasterComponent } from './employeemaster/employeemaster.component';
import { EmployeeattendanceComponent } from './employeeattendance/employeeattendance.component';
import { EmployeeAttendanceComponent } from './employee-attendance/employee-attendance.component';
import { AdminAttendanceComponent } from './admin-attendance/admin-attendance.component';
import { SharedModule } from '../shared/shared.module';
import { SpeakUpComponent } from './speak-up/speak-up.component';
import { TemplatesComponent } from './templates/templates.component';
import { HolidayComponent } from './holiday/holiday.component';
import { LeavemasterComponent } from './leavemaster/leavemaster.component';
import { ReleaseComponent } from './release/release.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExitManagmentComponent } from './exit-managment/exit-managment.component';
import { EmployeeIdCardComponent } from './admin/components/employee-id-card/employee-id-card.component';
import { JoiningDashboardComponent } from './joining-dashboard/joining-dashboard.component';
import { InducationComponent } from './pages/inducation/inducation.component';
import { EsicComponent } from './pages/esic/esic.component';
import { MediclaimsComponent } from './pages/mediclaims/mediclaims.component';
import { EducationKitComponent } from './pages/education-kit/education-kit.component';
import { Covid19Component } from './pages/covid19/covid19.component';
import { SiteManagerBuddyComponent } from './site-manager-buddy/site-manager-buddy.component';
import { EmployeeJoiningKitComponent } from './pages/employee-joining-kit/employee-joining-kit.component';
import { EapComponent } from './pages/eap/eap.component';
import { GratuityComponent } from './pages/gratuity/gratuity.component';
import { BirthdayComponent } from './pages/birthday/birthday.component';
import { ExpensesComponent } from './expenses/expenses.component';
import { NewExpensesComponent } from './new-expenses/new-expenses.component';
import { NewReportComponent } from './new-report/new-report.component';
import { MicroloanComponent } from './microloan/microloan.component';
import { WorkplacePermissionComponent } from './workplace-permission/workplace-permission.component';
import { DownloadQrCodeComponent } from './download-qr-code/download-qr-code.component';
import { StickyIconsComponent } from 'src/app/shared/components/sticky-icons/sticky-icons.component';
import { MediclaiminformationComponent } from './mediclaiminformation/mediclaiminformation.component';
import { MinimumwageComponent } from './minimumwage/minimumwage.component';
import { SelfCovidDeclarationFormComponent } from './self-covid-declaration-form/self-covid-declaration-form.component';
import { VaccinReqFormComponent } from './pages/vaccin-req-form/vaccin-req-form.component';
import { IJPSGADashboardComponent } from './pages/ijp-sga-dashboard/ijp-sga-dashboard.component';
import { VaccinationCampTrackerComponent } from './pages/vaccination-camp-tracker/vaccination-camp-tracker.component';
import { WorkplacePermissionDashboardComponent } from './pages/workplace-permission-dashboard/workplace-permission-dashboard.component';
import { SPOCCenterDashboardComponent } from './pages/spoccenter-dashboard/spoccenter-dashboard.component';
import { FnfDashboardComponent } from './pages/fnf-dashboard/fnf-dashboard.component';
import { MRFOnHoldComponent } from './pages/mrfon-hold/mrfon-hold.component';
import { PayrollManagementDashboardComponent } from './pages/payroll-management-dashboard/payroll-management-dashboard.component';
import { RBCCompletionDashboardComponent } from './pages/rbccompletion-dashboard/rbccompletion-dashboard.component';
import { IndiaTaDashboardComponent } from './pages/india-ta-dashboard/india-ta-dashboard.component';
import { WpdIvrDashboardComponent } from './pages/wpd-ivr-dashboard/wpd-ivr-dashboard.component';
import { PortalLinkComponent } from './admin/components/portal-link/portal-link.component';
import { SeatAvailabilityComponent } from './pages/seat-availability/seat-availability.component';
import { HyderabadComponent } from './pages/hyderabad/hyderabad.component';
import { ChennaiComponent } from './pages/chennai/chennai.component';
import { NoidaComponent } from './pages/noida/noida.component';
import { PuneComponent } from './pages/pune/pune.component';
import { GoregaonComponent } from './pages/goregaon/goregaon.component';
import { MaladComponent } from './pages/malad/malad.component';
import { AccommodationComponent } from './pages/accommodation/accommodation.component';
import { ChartComponent } from './pages/chart/chart.component';
import { ApprovalsComponent } from './pages/approvals/approvals.component';
import { FoodOrderComponent } from './food-order/food-order.component';
import { FoodOrderListComponent } from './food-order-list/food-order-list.component';
import { TravalBookingComponent } from './traval-booking/traval-booking.component';
import { TravalContractlistComponent } from './pages/traval-contractlist/traval-contractlist.component';
import { TravalSearchComponent } from './pages/traval-search/traval-search.component';
import { NewdashboardComponent } from './newdashboard/newdashboard.component';
import { EmployeeVisitingCardComponent } from './admin/components/employee-visiting-card/employee-visiting-card.component';
import { RefyneComponent } from './refyne/refyne.component';
import { NewsLandingPageComponent } from './admin/components/news-landing-page/news-landing-page.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { YouTubePlayerModule } from '@angular/youtube-player';

@NgModule({
  declarations: [
    AdminComponent,
    MrfEmployeeListComponent,
    CreatekicketComponent,
    TicketmasterComponent,
    EmployeeprofileComponent,
    EmployeemasterComponent,
    EmployeeattendanceComponent,
    EmployeeAttendanceComponent,
    AdminAttendanceComponent,
    SpeakUpComponent,
    TemplatesComponent,
    HolidayComponent,
    LeavemasterComponent,
    ReleaseComponent,
    ExitManagmentComponent,
    EmployeeIdCardComponent,
    JoiningDashboardComponent,
    InducationComponent,
    EsicComponent,
    MediclaimsComponent,
    EducationKitComponent,
    Covid19Component,
    SiteManagerBuddyComponent,
    EmployeeJoiningKitComponent,
    EapComponent,
    GratuityComponent,
    BirthdayComponent,
    ExpensesComponent,
    NewExpensesComponent,
    NewReportComponent,
    MicroloanComponent,
    WorkplacePermissionComponent,
    DownloadQrCodeComponent,
    StickyIconsComponent,
    MediclaiminformationComponent,
    MinimumwageComponent,
    SelfCovidDeclarationFormComponent,
    VaccinReqFormComponent,
    IJPSGADashboardComponent,
    VaccinationCampTrackerComponent,
    WorkplacePermissionDashboardComponent,
    SPOCCenterDashboardComponent,
    FnfDashboardComponent,
    MRFOnHoldComponent,
    PayrollManagementDashboardComponent,
    RBCCompletionDashboardComponent,
    IndiaTaDashboardComponent,
    WpdIvrDashboardComponent,
    PortalLinkComponent,
    SeatAvailabilityComponent,
    HyderabadComponent,
    ChennaiComponent,
    NoidaComponent,
    PuneComponent,
    GoregaonComponent,
    MaladComponent,
    AccommodationComponent,
    ChartComponent,
    ApprovalsComponent,
    FoodOrderComponent,
    FoodOrderListComponent,
    TravalBookingComponent,
    TravalContractlistComponent,
    TravalSearchComponent,
    NewdashboardComponent,
    EmployeeVisitingCardComponent,
    RefyneComponent,
    NewsLandingPageComponent,
  ],
  imports: [
    CommonModule,
    CarouselModule,
    DasboardRoutingModule,
    DragDropModule,
    MatButtonModule,
    MatIconModule,
    Select2Module,
    MatSortModule,
    UiSwitchModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    AngularEditorModule,
    YouTubePlayerModule,
  ],
  exports: [
    ChennaiComponent,
    SeatAvailabilityComponent,
    HyderabadComponent,
    NoidaComponent,
    PortalLinkComponent,
    EmployeeIdCardComponent,
    NewsLandingPageComponent
  ],
})
export class DasboardModule {}
